import { jsx as _jsx } from "react/jsx-runtime";
import "./DoraButton.scss";
import classnames from "classnames";
const DoraButton = (props) => {
    const { variant, className, ...rest } = props;
    const classes = classnames("dora-button", {
        "dora-button--primary": variant === "primary",
        "dora-button--primary-filled": variant === "primary-filled",
        "dora-button--error": variant === "error",
        "dora-button--ghost": variant === "ghost",
    }, className);
    return _jsx("button", { className: classes, ...rest });
};
export default DoraButton;
//# sourceMappingURL=DoraButton.js.map